/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

// Handle pagination link clicks (debug only)
function initPagination( root ) {
	const containers = root.querySelectorAll( '.wp-block-gc-argentum-pagination' );
	console.log( '[Pagination Debug] Found ' + containers.length + ' pagination containers' );
	
	containers.forEach( ( container ) => {
		const currentPage = container.getAttribute( 'data-debug-current-page' );
		const totalPages = container.getAttribute( 'data-debug-total-pages' );
		console.log( '[Pagination Debug] Container - Current Page: ' + currentPage + ', Total Pages: ' + totalPages );
	} );

	// Allow native anchor navigation to handle pagination
}

if ( document.readyState === 'loading' ) {
	document.addEventListener( 'DOMContentLoaded', () => {
		console.log( '[Pagination Debug] DOMContentLoaded fired' );
		initPagination( document );
	} );
} else {
	console.log( '[Pagination Debug] Document already loaded, initializing immediately' );
	initPagination( document );
}

